"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocale = void 0;
const react_1 = require("react");
const self_xss_warning_1 = require("@snapchat/self-xss-warning");
const locales_1 = require("../lib/locales");
/**
 * Stores locale when needed on a page
 */
function useLocale(params) {
    const { defaultLocale, defaultMessages, loadMessages, skipRedirectToLocaleUrl } = params ?? {};
    const [state, setState] = (0, react_1.useState)(() => ({
        locale: (0, locales_1.getLocale)(defaultLocale),
        messages: defaultMessages,
    }));
    const isMounted = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    const updateLocale = (0, react_1.useCallback)((locale) => {
        setState((prev) => ({
            ...prev,
            locale,
        }));
        // load messages for new locale
        (0, self_xss_warning_1.printWarning)(locale);
        void loadMessages?.(locale).then((updatedMessages) => {
            // to prevent memory leak on unmounted component
            if (isMounted.current) {
                setState((prev) => ({
                    ...prev,
                    messages: updatedMessages,
                }));
            }
        });
    }, [loadMessages]);
    (0, react_1.useEffect)(() => {
        updateLocale((0, locales_1.getLocale)(defaultLocale));
    }, [defaultLocale, updateLocale]);
    const changeLocale = (0, react_1.useCallback)((newLocale) => {
        if (skipRedirectToLocaleUrl) {
            updateLocale((0, locales_1.getLocale)(newLocale));
            return;
        }
        updateRouteWithNewLocale(newLocale);
    }, [updateLocale, skipRedirectToLocaleUrl]);
    return { ...state, changeLocale };
}
exports.useLocale = useLocale;
function updateRouteWithNewLocale(newLocale) {
    /* istanbul ignore next -- will never execute in server side */
    // eslint-disable-next-line no-restricted-globals
    if (typeof window === "undefined") {
        return;
    }
    // eslint-disable-next-line no-restricted-globals
    const currentURL = new URL(window.location.href);
    const queryParams = new URLSearchParams(currentURL.search);
    // setting new locale in the query params
    queryParams.set("locale", newLocale);
    currentURL.search = queryParams.toString();
    // replacing the URL
    // eslint-disable-next-line no-restricted-globals
    window.location.replace(currentURL);
}
//# sourceMappingURL=useLocale.js.map